import { useState } from 'react';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

export default function InvestirPage() {
  const [formData, setFormData] = useState({
    nome: '',
    email: '',
    whatsapp: '',
    valorInvestimento: '',
    objetivo: '',
    mensagem: '',
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitSuccess, setSubmitSuccess] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);

    const formBody = new URLSearchParams();
    Object.entries(formData).forEach(([key, value]) => {
      formBody.append(key, value);
    });

    try {
      const response = await fetch('https://readdy.ai/api/form/d63mmp5si3r5mpi9v1b0', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formBody.toString(),
      });

      if (response.ok) {
        setSubmitSuccess(true);
        setFormData({
          nome: '',
          email: '',
          whatsapp: '',
          valorInvestimento: '',
          objetivo: '',
          mensagem: '',
        });
      }
    } catch (error) {
      console.error('Erro ao enviar formulário:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen">
      <Navbar />
      <main className="pt-20">
        <section className="relative h-[50vh] overflow-hidden">
          <div className="absolute inset-0">
            <img
              src="https://public.readdy.ai/ai/img_res/1ced8a19e1fd514950808bdf7e3da954.jpg"
              alt="Investir com a Bravia Group"
              className="w-full h-full object-cover object-center"
            />
            <div className="absolute inset-0 bg-black/50"></div>
          </div>
          <div className="relative h-full max-w-7xl mx-auto px-6 lg:px-12 flex items-center">
            <div className="max-w-3xl">
              <h1 className="text-6xl font-bold text-white mb-6">
                Investir em construção na Flórida com clareza e acompanhamento
              </h1>
            </div>
          </div>
        </section>

        <section className="bg-white py-24">
          <div className="max-w-5xl mx-auto px-6 lg:px-12">
            <div className="prose prose-lg max-w-none mb-16">
              <p className="text-xl text-gray-700 leading-relaxed">
                A Bravia Group oferece a oportunidade de participar de projetos de construção residencial na Flórida com processo transparente, acompanhamento constante e foco em resultados consistentes.
              </p>
              <p className="text-xl text-gray-700 leading-relaxed">
                Nosso modelo é baseado em clareza, documentação completa e comunicação frequente. Você sabe exatamente onde está investindo, como o projeto está progredindo e quais são as expectativas realistas de retorno.
              </p>
            </div>

            <div className="bg-beige-50 rounded-2xl p-10 mb-12">
              <h2 className="text-3xl font-bold text-black mb-8">Para quem é</h2>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div className="flex items-start">
                  <i className="ri-check-line text-2xl text-gold-500 mr-3 mt-1"></i>
                  <p className="text-gray-700">Investidores brasileiros buscando diversificação internacional</p>
                </div>
                <div className="flex items-start">
                  <i className="ri-check-line text-2xl text-gold-500 mr-3 mt-1"></i>
                  <p className="text-gray-700">Pessoas interessadas no mercado imobiliário americano</p>
                </div>
                <div className="flex items-start">
                  <i className="ri-check-line text-2xl text-gold-500 mr-3 mt-1"></i>
                  <p className="text-gray-700">Quem busca investimentos com acompanhamento transparente</p>
                </div>
                <div className="flex items-start">
                  <i className="ri-check-line text-2xl text-gold-500 mr-3 mt-1"></i>
                  <p className="text-gray-700">Investidores que valorizam previsibilidade e qualidade</p>
                </div>
              </div>
            </div>

            <div className="bg-white border-2 border-gray-200 rounded-2xl p-10 mb-12">
              <h2 className="text-3xl font-bold text-black mb-8">O que você recebe</h2>
              <div className="space-y-6">
                <div className="flex items-start">
                  <div className="w-12 h-12 bg-gold-500/10 rounded-full flex items-center justify-center mr-4 flex-shrink-0">
                    <i className="ri-camera-line text-xl text-black"></i>
                  </div>
                  <div>
                    <h3 className="text-xl font-bold text-black mb-2">Acompanhamento de obra</h3>
                    <p className="text-gray-700">Relatórios semanais com fotos, vídeos e atualizações detalhadas do progresso da construção</p>
                  </div>
                </div>
                <div className="flex items-start">
                  <div className="w-12 h-12 bg-gold-500/10 rounded-full flex items-center justify-center mr-4 flex-shrink-0">
                    <i className="ri-notification-line text-xl text-black"></i>
                  </div>
                  <div>
                    <h3 className="text-xl font-bold text-black mb-2">Atualizações regulares</h3>
                    <p className="text-gray-700">Comunicação constante sobre cronograma, custos e qualquer mudança no projeto</p>
                  </div>
                </div>
                <div className="flex items-start">
                  <div className="w-12 h-12 bg-gold-500/10 rounded-full flex items-center justify-center mr-4 flex-shrink-0">
                    <i className="ri-file-list-3-line text-xl text-black"></i>
                  </div>
                  <div>
                    <h3 className="text-xl font-bold text-black mb-2">Documentos do projeto</h3>
                    <p className="text-gray-700">Acesso completo a contratos, licenças, relatórios financeiros e toda documentação</p>
                  </div>
                </div>
                <div className="flex items-start">
                  <div className="w-12 h-12 bg-gold-500/10 rounded-full flex items-center justify-center mr-4 flex-shrink-0">
                    <i className="ri-customer-service-line text-xl text-black"></i>
                  </div>
                  <div>
                    <h3 className="text-xl font-bold text-black mb-2">Suporte do time</h3>
                    <p className="text-gray-700">Equipe dedicada para responder dúvidas e fornecer suporte durante todo o processo</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="bg-gradient-to-br from-gray-900 to-gray-800 rounded-2xl p-10 text-white mb-12">
              <h2 className="text-3xl font-bold mb-8">Números do modelo</h2>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
                <div>
                  <div className="text-4xl font-bold text-gold-500 mb-2">$22k+</div>
                  <p className="text-gray-300">Investimento mínimo</p>
                </div>
                <div>
                  <div className="text-4xl font-bold text-gold-500 mb-2">9-11</div>
                  <p className="text-gray-300">Meses de prazo médio</p>
                </div>
                <div>
                  <div className="text-4xl font-bold text-gold-500 mb-2">14-18%</div>
                  <p className="text-gray-300">Retorno estimado</p>
                </div>
              </div>
              <div className="border-t border-gray-700 pt-6">
                <p className="text-sm text-gray-400 italic leading-relaxed">
                  <strong>Importante:</strong> Os retornos apresentados são estimativas baseadas em análises de mercado e histórico de projetos anteriores. Não há garantia de retorno. Todo investimento envolve riscos, incluindo possibilidade de perda parcial ou total do capital investido. Recomendamos consultar um assessor financeiro antes de investir.
                </p>
              </div>
            </div>
          </div>
        </section>

        <section className="bg-beige-50 py-24">
          <div className="max-w-3xl mx-auto px-6 lg:px-12">
            <div className="text-center mb-12">
              <h2 className="text-4xl font-bold text-black mb-4">Quer entender qual projeto faz sentido pra você?</h2>
              <p className="text-xl text-gray-600">Preencha o formulário e nossa equipe entrará em contato</p>
            </div>

            {submitSuccess ? (
              <div className="bg-green-50 border-2 border-green-500 rounded-2xl p-12 text-center">
                <i className="ri-checkbox-circle-line text-6xl text-green-500 mb-4"></i>
                <h3 className="text-2xl font-bold text-black mb-2">Perfeito!</h3>
                <p className="text-lg text-gray-700">Recebemos seus dados e vamos te chamar em breve.</p>
              </div>
            ) : (
              <form onSubmit={handleSubmit} className="bg-white rounded-2xl p-10 shadow-lg" data-readdy-form id="investir-form">
                <div className="space-y-6">
                  <div>
                    <label htmlFor="nome" className="block text-sm font-semibold text-gray-900 mb-2">
                      Nome completo *
                    </label>
                    <input
                      type="text"
                      id="nome"
                      name="nome"
                      required
                      value={formData.nome}
                      onChange={(e) => setFormData({ ...formData, nome: e.target.value })}
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-gold-500 focus:border-transparent text-base"
                    />
                  </div>

                  <div>
                    <label htmlFor="email" className="block text-sm font-semibold text-gray-900 mb-2">
                      Email *
                    </label>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      required
                      value={formData.email}
                      onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-gold-500 focus:border-transparent text-base"
                    />
                  </div>

                  <div>
                    <label htmlFor="whatsapp" className="block text-sm font-semibold text-gray-900 mb-2">
                      WhatsApp *
                    </label>
                    <input
                      type="tel"
                      id="whatsapp"
                      name="whatsapp"
                      required
                      value={formData.whatsapp}
                      onChange={(e) => setFormData({ ...formData, whatsapp: e.target.value })}
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-gold-500 focus:border-transparent text-base"
                      placeholder="+55 11 99999-9999"
                    />
                  </div>

                  <div>
                    <label htmlFor="valorInvestimento" className="block text-sm font-semibold text-gray-900 mb-2">
                      Valor aproximado para investir (opcional)
                    </label>
                    <select
                      id="valorInvestimento"
                      name="valorInvestimento"
                      value={formData.valorInvestimento}
                      onChange={(e) => setFormData({ ...formData, valorInvestimento: e.target.value })}
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-gold-500 focus:border-transparent text-base"
                    >
                      <option value="">Selecione uma faixa</option>
                      <option value="$22k - $50k">$22k - $50k</option>
                      <option value="$50k - $100k">$50k - $100k</option>
                      <option value="$100k - $200k">$100k - $200k</option>
                      <option value="$200k+">$200k+</option>
                    </select>
                  </div>

                  <div>
                    <label htmlFor="objetivo" className="block text-sm font-semibold text-gray-900 mb-2">
                      Objetivo *
                    </label>
                    <select
                      id="objetivo"
                      name="objetivo"
                      required
                      value={formData.objetivo}
                      onChange={(e) => setFormData({ ...formData, objetivo: e.target.value })}
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-gold-500 focus:border-transparent text-base"
                    >
                      <option value="">Selecione seu objetivo</option>
                      <option value="Investir em projeto">Investir em projeto</option>
                      <option value="Conhecer melhor">Conhecer melhor</option>
                      <option value="Parceria">Parceria</option>
                    </select>
                  </div>

                  <div>
                    <label htmlFor="mensagem" className="block text-sm font-semibold text-gray-900 mb-2">
                      Mensagem (opcional)
                    </label>
                    <textarea
                      id="mensagem"
                      name="mensagem"
                      rows={4}
                      maxLength={500}
                      value={formData.mensagem}
                      onChange={(e) => setFormData({ ...formData, mensagem: e.target.value })}
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-gold-500 focus:border-transparent text-base resize-none"
                      placeholder="Conte um pouco sobre seu interesse..."
                    ></textarea>
                    <p className="text-sm text-gray-500 mt-1">{formData.mensagem.length}/500 caracteres</p>
                  </div>

                  <button
                    type="submit"
                    disabled={isSubmitting}
                    className="w-full py-4 bg-black text-white rounded-full font-semibold text-lg hover:bg-gray-800 transition-all disabled:opacity-50 disabled:cursor-not-allowed whitespace-nowrap cursor-pointer"
                  >
                    {isSubmitting ? 'Enviando...' : 'Quero falar com a Bravia'}
                  </button>
                </div>
              </form>
            )}
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
